import { createReducer } from 'redux-starter-kit';
import { putTranslations } from './translationsActions';

/**
 * A selector for all of the translations.
 * @param {object} state The redux state of the application.
 * @param {string} locale The localeCode for the langue of translations you want. E.G es_MX
 */
export const selectTranslations = (state) => {
  const { translations } = state.via.domain;
  if (!translations) return undefined;

  return translations;
};

/**
 * A reducer for managing the Application Config in the domain.
 */
const translationsReducer = createReducer(null, {
  // Inserts/Updates the video options
  [putTranslations]: (state, action) => {
    const translations = action.payload;
    const locale = action.payload.translationLocale;
    return {
      ...state,
      [locale]: translations,
    };
  },
});

export default translationsReducer;
